import React from 'react';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';

export function DeletePowerlistModal({
  deleteId,
  handleClose,
  show,
  handleDeletion,
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        handleDeletion(values.deleteId);
        actions.resetForm({});
        handleClose();
      }}
      enableReinitialize={true}
      initialValues={{
        deleteId: deleteId ?? '',
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              dataPup="confirm-delete-powerlist"
              onSubmit={formik.handleSubmit}
              title="Delete Powerlist"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                Deleting this Powerlist will prevent any deferred contacts from
                being dialed as part of this Powerlist. This action cannot be
                reversed.
              </p>
              <p>Are you sure you want to delete this powerlist?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
